/**
 * A flag's choices as buttons: the codes a person may pick for a flagged field.
 *
 * Found on UAT, 2026-10-05: the client's summary gave 99872, which GSTN does not publish,
 * and the flag named the codes under it in a sentence. Nothing on screen could act on it —
 * the line was clean, so it had no correction control — and the line went to Prepare with
 * no HSN, which blocks Table 12. Each choice is now a button that sends the ordinary,
 * audited correction; the code is remembered for the item, as any typed code is.
 */

import type { ReviewFlag } from './api'

export type FlagChoice = { code: string; description: string }

/** The choices a flag offers, or none. Only a field the correction call takes. */
export function flagChoices(flag: ReviewFlag): FlagChoice[] {
  return flag.field === 'hsn' ? (flag.choices ?? []) : []
}

/** The correction one press sends: this line, this field, this code. */
export function choiceCorrection(
  flag: ReviewFlag,
  choice: FlagChoice,
): { content_key: string; field: string; value: string } {
  return { content_key: flag.content_key, field: flag.field, value: choice.code }
}

/** "Use 998729 — Maintenance and repair services of other goods n.e.c.", cut to fit a button. */
export function choiceLabel(choice: FlagChoice, max = 48): string {
  const head = `Use ${choice.code}`
  const words = choice.description.trim()
  if (!words) return head
  const full = `${head} — ${words}`
  return full.length <= max ? full : `${full.slice(0, max - 1).trimEnd()}…`
}
